import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import FormInput from 'components/forms/FormInput';
import { confirmAlert } from 'react-confirm-alert';
import { forEach as _forEach } from 'lodash';
import Modal from '../../Modal';
import CampaignSettings from './CampaignSettings';
import { deleterDispatchHelper } from '../../../actions/DeleterActions';
import Data from '../../Data';
import Loader from '../Loader';
import Breadcrumb from '../Breadcrumb';
import Edition from './Edition';
import ProductSelection from './ProductSelection';
import { cartAddEdition } from '../../../actions/CartActions';
import { newEditionR, setVariables, setPreviewImageR } from '../../../actions/CampaignActions';
import { getDeviceType } from '../../../cc-editor/components/actions/deviceType';
import { storeCampaignR } from '../../../actions/ListActions';
import Tabs from 'components/layout/Tabs';
import SubmissionsList from 'components/layout/campaigns/SubmissionsList';

class CampaignDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewEdition: false,
      showSettings: false,
      deleting: false,
      action: 'new',
      generatingEdition: false,
      newEditionItem: null,
      selectedSubmission: null,
      submissionSelected: false,
      newEditionTemplate: null,
      newItemName: '',
      productSelected: false,
      ordering: false,
      deviceTypes: '',
      newItemDirectOrdering: false,
      selectedModalTab: 0,
    };
  }

  setSelectedSubmission = submission => {
    console.log('setSelectedSubmission', submission);
    this.setState({
      selectedSubmission: submission,
      submissionSelected: submission !== null,
    });
  };

  setSelectedModalTab = tabIndex => {
    this.setState({ selectedModalTab: tabIndex });
  };

  componentDidUpdate = prevProps => {
    const { history, appIntl, forwardingR, addToCart, cartPending, setPreviewImageR, pendingR } = this.props;
    const { newItemDirectOrdering } = this.state;
    if (forwardingR !== prevProps.forwardingR) {
      if (newItemDirectOrdering !== true) {
        history.push(appIntl.urlPrefix + 'editor/' + forwardingR);
      } else {
        // create Images for preview in campaign details and cart
        // editionId as forwardingR
        setPreviewImageR(forwardingR);
      }

      /* when creating an edition, after being redirected to the editor,
      the page is reloaded a second time.. this shouldn't be the case..
      removed this line..
      reload (false) from cache. only commented out if needed again
       */
      // window.location.reload(false);
    }

    if (prevProps.pendingR !== pendingR && pendingR === false) {
      const edition = { id: forwardingR };
      addToCart(edition);
    }

    if (prevProps.cartPending !== cartPending && cartPending === false && newItemDirectOrdering === true) {
      let cart = 'cart';
      if (appIntl.urlPrefix === '/de/') {
        cart = 'warenkorb';
      }
      history.push(appIntl.urlPrefix + cart);
    }
  };

  componentDidMount = () => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ deviceTypes: getDeviceType(), newItemName: messages?.no_product_selected });
  };

  showList = () => {
    const { history, appIntl } = this.props;
    history.push(appIntl.urlPrefix + 'account/campaigns');
  };

  newEdition = (campaignId, action = '', editionId = '') => {
    this.setState({
      generatingEdition: true,
      showNewEdition: false,
    });
    const {
      newEditionItem,
      newEditionTemplate,
      selectedModalTab,
      selectedSubmission
    } = this.state;
    const { newEditionR } = this.props;
    const {
      intl: { messages },
    } = this.props;
    let params;
    if (action !== 'copy' && selectedModalTab === 0) {
      params = {
        template: newEditionTemplate,
        item: newEditionItem,
        campaign: campaignId,
        title:
          this.editionTitle.state.value === '' ? messages.campaign.new_edition_title : this.editionTitle.state.value,
      };
    } else if ( selectedModalTab === 1) {
      params = {
        submissionId: this.state.selectedSubmission.id,
        campaign: campaignId,
        title:
          this.editionTitle.state.value === '' ? messages.campaign.new_edition_title : this.editionTitle.state.value,
      };
    } else {
      params = {
        id: editionId,
        action: 'copy',
      };
    }
    newEditionR(params);
  };

  showNewEdition = () => {
    this.setState({
      showNewEdition: true,
    });
  };

  closeNewEdition = () => {
    this.setState({
      showNewEdition: false,
    });
  };

  showSettings = action => {
    this.setState({
      showSettings: true,
      action,
    });
  };

  renewList = () => {
    this.forceUpdate();
  };

  closeSettings = () => {
    this.setState({
      showSettings: false,
      modalData: null,
    });
  };

  handleRemoveClick = (e, campaignId) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.deleteCampaign(campaignId, 'toTrash');
    window.setTimeout(this.showList, 1000);
  };

  handleRemoveEditionClick = (e, editionId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteEdition(editionId, 'toTrash');
  };

  selectItem = (templateId, itemId, itemName, itemDirectOrdering) => {
    this.setState({
      newEditionItem: itemId,
      newEditionTemplate: templateId,
      productSelected: true,
      newItemName: itemName,
      newItemDirectOrdering: itemDirectOrdering,
    });
    if(itemDirectOrdering === true) {
      // set this delay to make sure the value is set after the component is rendered
    setTimeout(() => {
      this.editionTitle.setState({ value: this.props.user.profile.first_name + ' ' + this.props.user.profile.last_name + '-' + itemName });
    }, 200);
    }
  };

  addToCart = () => {
    this.setState({ ordering: true });
    const { addToCart, data } = this.props;
    const campaign = data.data;

    for (let i = 0; i < campaign.editions.length; i++) {
      addToCart(campaign.editions[i]);
    }
    const showInterval = window.setInterval(() => {
      const { isCampaignInCart } = this.props;
      const {
        intl: { messages },
      } = this.props;
      if (isCampaignInCart() === true) {
        window.clearInterval(showInterval);
        this.setState({ ordering: false });
        const options = {
          customUI: ({ onClose }) => {
            return (
              <div className="react-confirm-alert-body">
                <h1>{messages.cart.title}</h1>
                <p>{messages.campaign.added_to_cart}</p>
                <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                  <Button
                    style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                    bsStyle="primary"
                    onClick={onClose}
                  >
                    OK
                  </Button>
                </div>
              </div>
            );
          },
          childrenElement: () => <div />,
          closeOnEscape: true,
          closeOnClickOutside: true,
        };

        confirmAlert(options);
      }
    }, 1000);
  };

  render() {
    const {
      match,
      data,
      intl: { messages },
      index,
      appIntl,
      history,
      user,
    } = this.props;
    const {
      showNewEdition,
      showSettings,
      action,
      generatingEdition,
      newEditionTemplate,
      productSelected,
      newItemName,
      deviceTypes,
      newItemDirectOrdering,
      submissionSelected,
      selectedModalTab,
      selectedSubmission
    } = this.state;

    let campaign;
    if (typeof data !== 'undefined' && !data.pending) {
      campaign = data.data;
    }

    return (
      <div className="campaign padding-25 sm-padding-10" key={index}>
        <Data dataName="campaign" url={'/api/campaigns/' + match.params.campaignId + '.json'} data={data} />

        {typeof data !== 'undefined' ? (
          data.pending || data.data.id !== match.params.campaignId ? (
            <Loader />
          ) : (
            <>
              <Breadcrumb
                crumbs={[
                  { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
                  { link: appIntl.urlPrefix + 'account/campaigns', name: messages.meta.campaigns.name },
                  { link: null, name: campaign.title },
                ]}
                className="p-t-0"
              />
              {showSettings && (
                <Modal show={showSettings} className="creacheck-modal" onHide={() => this.closeSettings()} bsSize="lg">
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <CampaignSettings
                      campaign={campaign}
                      closeSettings={this.closeSettings}
                      messages={messages}
                      renewList={this.renewList}
                      action={action}
                      history={history}
                      deleter={this.handleRemoveClick}
                      user={user}
                      storeCampaignR={this.props.storeCampaignR}
                      showSettingsAbout="campaignDetails"
                    />
                  </Modal.Body>
                </Modal>
              )}
              {showNewEdition && (
                <Modal
                  show={showNewEdition}
                  className="creacheck-modal"
                  onHide={() => this.closeNewEdition()}
                  bsSize="large"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{campaign.title + ': ' + messages.campaign.new_edition}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Tabs
                      tabs={[messages.campaign.modal_tabs.default_edition, messages.campaign.modal_tabs.edition_from_submission]}
                      onTabChange={this.setSelectedModalTab}
                      tabContent={[
                        <div className="new-edition">
                          <div className="select-product">
                            <ProductSelection
                              messages={messages}
                              appIntl={appIntl}
                              history={history}
                              selectItem={this.selectItem}
                              selectedItem={newEditionTemplate}
                              deviceTypes={deviceTypes}
                            />
                          </div>
                        </div>,
                        <SubmissionsList
                          urlData={{}}
                          onlyForSelection={true}
                          setSelectedSubmission={this.setSelectedSubmission}
                        />,
                      ]}
                      keepMounted={[0, 1]}
                    />
                    <div className="edition-settings">
                      <p>
                        <b>{(selectedModalTab === 0 ? messages.campaign.edition_item : messages.campaign.submission_item) + ': '}</b>
                        { selectedModalTab === 0
                          ? newItemName
                          : selectedSubmission?.title}
                      </p>
                      <FormInput
                        type="text"
                        label={messages.campaign.edition_title}
                        name="title"
                        value={messages.campaign.new_edition_title}
                        ref={ref => (this.editionTitle = ref)}
                      />
                      <Button
                        bsStyle="default"
                        disabled={(selectedModalTab === 0 && !productSelected) || (selectedModalTab === 1 && !submissionSelected)}
                        bsSize="large"
                        onClick={() => this.newEdition(campaign.id)}
                      >
                        <i className="fas fa-plus-square bg-green" />{' '}
                        {newItemDirectOrdering ? messages.add_to_cart : messages.campaign.new_edition}
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              )}
              <div>
                <header>
                  <div className="header-left header-campaign-title">
                    <i className="fad fa-chevron-circle-left" onClick={() => this.showList()} />{' '}
                    <span>{campaign.title}</span>
                  </div>
                  <div className="header-fill" />
                  <div className="header-right">
                    <Button
                      bsStyle="default"
                      className="bg-red"
                      bsSize="small"
                      onClick={() => this.showSettings('edit')}
                    >
                      <i className="fas fa-cog" />{' '}
                    </Button>
                  </div>
                </header>
              </div>
              <div className="editions">
                {generatingEdition ? (
                  <Loader />
                ) : (
                  <>
                    <div className="editionNew">
                      <Button
                        bsStyle="default"
                        className="new-ce"
                        disabled={generatingEdition}
                        bsSize="small"
                        onClick={() => this.showNewEdition()}
                      >
                        <i className="fas fa-plus bg-green" />
                        <span>{messages.campaign.new_edition}</span>
                      </Button>
                      {/*
                    <Button bsStyle="default" style={{marginLeft:"20px"}} className="new-ce" bsSize="small" onClick={() => this.addToCart()}>
                      {ordering ? <i style={{padding:"10px", marginRight:"10px", fontSize:"20px"}} className="far fa-spin fa-spinner-third"/> :
                      <i className="fas fa-plus bg-green"/>}
                      <span>{messages.campaign.order_all}</span>
                    </Button>
                    */}
                    </div>
                    {campaign.editions.map(edition => {
                      return (
                        <Edition
                          edition={edition}
                          appIntl={appIntl}
                          messages={messages}
                          history={history}
                          deleter={this.handleRemoveEditionClick}
                          forceUpdate={this.forceUpdate}
                          copyEdition={this.newEdition}
                          onMobile={edition.item.category.on_mobile}
                          key={edition?.id}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            </>
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.campaigns,
    user: state.login.user,
    data: state.data.campaign,
    forwardingR: state.campaigns.forwardingR,
    cartPending: state.cart.addToCartPending,
    pendingR: state.campaigns.pendingR,
    isCampaignInCart: () => {
      let inCart = 0;
      _forEach(state.data.campaign.data.editions, edition => {
        if (state.cart.items.find(item => item.edition.id === edition.id)) {
          inCart++;
        }
      });
      // TODO inCart ergibt niemals inCart === state.data.campaign.data.editions.length; x gleich x wenn bereits editionen im warenkorb liegen

      return inCart === state.data.campaign.data.editions.length;
    },
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteCampaign: (campaignId, flagOption) => {
      deleterDispatchHelper('campaign', '/api/news/' + campaignId + '/campaigns/' + flagOption + '.json', dispatch);
    },
    deleteEdition: (editionId, flagOption) => {
      deleterDispatchHelper('edition', '/api/news/' + editionId + '/editions/' + flagOption + '.json', dispatch);
    },
    addToCart: edition => {
      dispatch(cartAddEdition(edition));
    },
    newEditionR: data => {
      dispatch(newEditionR(data));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
    storeCampaignR: (campaignId, option) => {
      dispatch(storeCampaignR(campaignId, option));
    },
    setPreviewImageR: data => {
      dispatch(setPreviewImageR(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CampaignDetails)
  )
);
